// Light / dark theme (Oct 2026). Dark is the default; each person's choice is remembered in this browser.
// The light colours live in App.css under :root[data-theme="light"].
const KEY = 'inv_theme'

export function getTheme() {
  try { return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark' } catch (e) { return 'dark' }
}

export function applyTheme(theme) {
  if (theme === 'light') document.documentElement.setAttribute('data-theme', 'light')
  else document.documentElement.removeAttribute('data-theme')
}

export function setTheme(theme) {
  try { localStorage.setItem(KEY, theme) } catch (e) { /* storage blocked: applies for this visit only */ }
  applyTheme(theme)
}
